import MUIIconButton, { IconButtonProps } from '@mui/material/IconButton/IconButton';
import React, { useMemo } from 'react';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material';
import { getColor, IconColor } from './SvgIcon';

type Props = Omit<IconButtonProps, 'color'> & {
  color?: IconColor;
  hoverColor?: IconColor;
  backgroundColor?: string;
  sx?: SxProps<Theme>;
};

export default function IconButton(props: Props) {
  const { hoverColor, color, backgroundColor, sx, ...rest } = props;
  const colorValue = getColor(color || 'blue');
  const defaultSx = useMemo(
    () => ({
      backgroundColor: backgroundColor,
      '.MuiSvgIcon-root': {
        color: colorValue,
      },
      '&:hover': {
        backgroundColor: backgroundColor,
      },
      '&:hover .MuiSvgIcon-root': {
        color: getColor(hoverColor) ?? colorValue,
      },
    }),
    [props.color, backgroundColor],
  );

  return (
    <MUIIconButton sx={{ ...defaultSx, ...sx }} {...rest}>
      {props.children}
    </MUIIconButton>
  );
}
